import React from 'react'
import ModalContainer from '../../../../../Modals/ModalContainer'
import { DialogContent } from '@mui/material';
import moment from 'moment';

function SyndicatedDetailsModal({ syndicationDetails, onClickClose }) {

    return (
        <ModalContainer
            title={`Offer Syndication Details`}
            maxWidth="sm"
            fullWidth="true"
            actions={{
                secondaryAction: { label: 'Close', onClick: onClickClose },
            }}>
            <DialogContent sx={{ paddingLeft: '0px', paddingRight: '0px', paddingTop: '0px' }}>
                This offer was syndicated from {syndicationDetails.syndicateListingName} on {moment(syndicationDetails.syndicateCreatedOnDateUtc).format('MM/DD/YYYY')}.
            </DialogContent>
        </ModalContainer>
    )
}

export default SyndicatedDetailsModal